/* unplugin-vue-components disabled */// extracted by css-extract-rspack-plugin
export default {"detailBox":"cost-detail-popup_detail-box__RYU+W","btn":"cost-detail-popup_btn__RWG7N"};